const widths = {
  small: 350,
  medium: 550,
  large: 850
};

const heights = {
  small: 250,
  medium: 300,
  large: 400
};

const innerRadii = {
  small: 60,
  medium: 75,
  large: 115
};


const width = size => (widths[size] || 400);
const height = size => (heights[size] || 400);
const innerRadius = size => (innerRadii[size] || 40);
const radius = size => (heights[size] || 400);

const exported = {
  width,
  height,
  innerRadius,
  radius
};

export default exported;
export { width, height, innerRadius, radius };
